import React, { Fragment } from 'react';
export const breakLines = (string) =>
    string.split('\\n').map((line, i) => (
        <Fragment key={i}>
            <span>{line}</span>
            <br />
        </Fragment>
    ));
